// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".internalActionDiv {\n  width: 100%;\n  height: 30px;\n}\n.internalActionDiv .q-btn-group {\n  position: absolute;\n  right: 0px;\n  padding-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
